import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store'

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import 'react-toastify/dist/ReactToastify.css'
import './index.css'
import './styles/banner.css'
import './styles/dropdown.css'
import './styles/slick.css'
import './styles/tailwind.css'
import './styles/react-pdf.css'

import App from './App'
import * as serviceWorker from './serviceWorker'
import { initializeIcons } from '@uifabric/icons'

initializeIcons()

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
